import * as React from 'react';

import Banner from '@atlaskit/banner';
import NotificationIcon from '@atlaskit/icon/glyph/notification';

export const BannerAnnouncement = (): JSX.Element => {
  return (
    <Banner
      appearance="announcement"
      icon={<NotificationIcon label="" secondaryColor="inherit" />}
    >
      Bifrost Baked Cookies website is under constuction, but we are on it.{' '}
      <a href="/components/banner/examples">Learn more details</a>
    </Banner>
  );
};
